<div class="p-card grid mt-4">
  <div class="col-12 md:col-4 bg-primary pl-4">
    <div class="text-base font-semibold">{{ product!.marketingInformation.productOfferingTitle || product!.name }}</div>
    <div class="text-8xl font-bold -mt-4 -mb-4">{{ product!.marketingInformation.speedDown }}</div>
    <div class="text-sm font-normal">
      Highspeed Internet mit<br />
      bis zu {{ product!.marketingInformation.speedDown }} MBit/s
    </div>
  </div>
  <div class="col-12 md:col-4 p-4">
    <div *ngFor="let includedProduct of includedProducts()" [ngSwitch]="includedProduct.type">
      <i class="fa-solid fa-globe text-primary mr-2" *ngSwitchCase="'Internet'"></i>
      <i class="fa-solid fa-phone text-primary mr-2" *ngSwitchCase="'Telefonie'"></i>
      <i class="fa-solid fa-check text-primary mr-2" *ngSwitchDefault></i>
      {{ includedProduct.name }}
    </div>
    <form class="flex flex-column gap-1 mt-3" [formGroup]="form" *ngIf="variantContractTimeProducts.length > 0">
      <div class="field-checkbox">
        <p-radioButton [inputId]="product!.name" [value]="product!.productId" formControlName="variantContractTimeProductId"></p-radioButton>
        <label [for]="product!.name" class="ml-2">24 Monate Laufzeit</label>
      </div>
      <div class="field-checkbox" *ngFor="let variantContractTimeProduct of variantContractTimeProducts">
        <p-radioButton [inputId]="variantContractTimeProduct.name" [value]="variantContractTimeProduct.productId" formControlName="variantContractTimeProductId"></p-radioButton>
        <label [for]="variantContractTimeProduct.name" class="ml-2">{{ variantContractTimeProduct.marketingInformation.contractTime }} Monate Laufzeit</label>
      </div>
    </form>
  </div>
  <div class="col-12 md:col-4">
    <div>
      ab
      <span class="text-xl font-semibold">{{ getSelectedProduct().marketingInformation.recurringMonthlyFee | currency:"EUR"}}</span>
      <i class="fa-solid fa-asterisk vertical-align-top ml-1 text-sm text-gray-500"></i>
      monatlich
    </div>
    <div *ngIf="regularBaseFee() !== getSelectedProduct().marketingInformation.recurringMonthlyFee">
      <span class="text-sm">{{ regularBaseFee() | currency:"EUR"}} ab dem {{ product!.discountMonths + 1 }}. Monat</span>
    </div>
    <p-button label="JETZT BESTELLEN" styleClass="w-full mt-2" (onClick)="chooseProduct()"></p-button>
    <a [href]="pibHref" target="_blank" *ngIf="pibHref">
      <button type="button" pButton label="TARIFDETAILS" class="p-button w-full mt-2"></button>
    </a>
  </div>
</div>
